import { InjectableClass } from '@fino/lib-injection';
import { FormRule } from '../../../../../common/ui/form/FormRule';
import {
  SIBLING_FIELDS,
  MODEL_FIELDS,
} from '../createRequest/createRequest.model';
import _ from 'lodash';

export class ReceivingCreateRequestService extends InjectableClass {
  constructor(RequestFields, envService, appConfig, formControlService) {
    'ngInject';
    super({ RequestFields, envService, appConfig, formControlService });

    this.formRules = {
      birthday: new FormRule(this.birthdayRule()),
      accountswitchSpecificDate: new FormRule(
        this.accountswitchSpecificDateRule(),
      ),
      refuseDebitsAndDepositsPartnerDeadline: new FormRule(
        this.refuseDebitsAndDepositsPartnerDeadlineDateRule(),
      ),
      accountCloseDeadline: new FormRule(this.accountCloseDeadlineDateRule()),
      oldIban: new FormRule(this.compareOldWithNewIban()),
      newIban: new FormRule(this.compareOldWithNewIban()),
    };

    this.legacyFormRulesForFormFields = {
      birthday: new FormRule(this.birthdayRule()),
      accountswitchSpecificDate: new FormRule(
        this.accountswitchSpecificDateRuleWithFormFields(),
      ),
      oldIban: new FormRule(this.compareOldWithNewIban()),
      newIban: new FormRule(this.compareOldWithNewIban()),
    };
  }

  fetchFields(parameters = {}) {
    return this.RequestFields.all(parameters).then((result) => {
      return result.data.state.fieldGroups;
    });
  }

  getConfig(key) {
    return _.get(this.appConfig, key);
  }

  setFormRules(rules) {
    angular.extend(this.formRules, rules);
  }

  birthdayRule() {
    const config = this.getConfig('ui.receivingRequest.createForm.checkAge');
    if (!config) {
      return angular.noop;
    }
    return (form, model, key, injections, newVal) => {
      // NOTE: This is probably not the "angular way"!
      const { $scope, $compile } = injections;
      const hintEl = $compile(
        '<p class="form-control-messages" translate="receiving.createRequest.form.error.underaged"></p>',
      )($scope);

      // Check age for underage and display error message when birthday yields to under 18
      const earliestDate = new Date().setFullYear(
        new Date().getFullYear() - 18,
      );
      const formControl = this.formControlService.setValidity(
        form['birthday'],
        'underaged',
        new Date(newVal) < earliestDate,
      );
      formControl.append(hintEl);
    };
  }

  passDateToSiblings(siblings) {
    return (form, model, key, injections, newVal) => {
      if (siblings && siblings.length) {
        siblings.map((field) => {
          model[field] = newVal;
        });
      }
    };
  }

  accountswitchSpecificDateRuleWithFormFields() {
    const siblings = this.getConfig(
      'ui.receivingRequest.createForm.accountswitchSpecificDateSiblings',
    );
    return this.passDateToSiblings(siblings);
  }

  accountCloseDeadlineDateRule() {
    return this.passDateToSiblings(
      SIBLING_FIELDS[MODEL_FIELDS.accountCloseDeadline],
    );
  }

  accountswitchSpecificDateRule() {
    return this.passDateToSiblings(
      SIBLING_FIELDS[MODEL_FIELDS.accountswitchSpecificDate],
    );
  }

  refuseDebitsAndDepositsPartnerDeadlineDateRule() {
    return this.passDateToSiblings(
      SIBLING_FIELDS[MODEL_FIELDS.refuseDebitsAndDepositsPartnerDeadline],
    );
  }

  compareOldWithNewIban() {
    return (form, model, key, injections, newVal) => {
      if (angular.isUndefined(newVal) || !form[key]) {
        return;
      }
      // Validate form control to show error when old and new ibans are equal
      const { oldIban, newIban } = model;
      this.formControlService.setValidity(
        form[key],
        'type',
        oldIban !== newIban,
      );
    };
  }
}
